import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
	jsonGridStyles: {
		border: '1px solid darkgrey',
		borderRadius: '4px',
		maxHeight: '500px',
		overflow: 'auto',
		padding: '2rem',
		width: '100%',
		marginTop: '4rem'
	},
	pageStyles: {
		padding: '1rem',
		margin: '2rem'
	},
	heading: {
		fontWeight: '600',
		color: theme.palette.primary.main,
		width: 'fit-content',
		textAlign: 'center',
		padding: 0,
		margin: '0 auto !important'
	},
	finalOverview: {
		position: 'absolute',
		top: '-40rem',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		width: '70vw !important',
		height: '70vh',
		backgroundColor: '#fff',
		boxShadow: 24,
		borderRadius: '10px',
		padding: '3rem',
		overflow: 'scroll'
	},
	icon: {
		cursor: 'pointer',
		margin: '4rem 7rem 0 -3rem',
		transform: 'scale(1.5)',
		transition: 'all .3s ease !important',
		'&:hover': {
			transform: 'scale(1.55)'
		},
		'&:active': {
			transform: 'scale(1.3)'
		}
	},
	modalContentStyle: {
		position: 'absolute',
		top: '10%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		minHeight: '35vh',
		maxHeight: '75vh',
		minWidth: '35vw',
		backgroundColor: '#fff',
		boxShadow: 24,
		borderRadius: '10px',
		padding: '2rem',
		overflowY: 'scroll'
	}
}));
